import {useState, useEffect} from 'react';

export const useTranslation = () => {
    const [translations, setTranslations] = useState({});

    useEffect(() => {
        fetch('/config/translation-config.json')
            .then(response => response.json())
            .then(data => setTranslations(data))
            .catch(err => console.error('Translation config error:', err));
    }, []);

    const translation = (key) => {
        return translations?.[key] || key;
    };

    return {translation};
};